module.exports = __webpack_public_path__ + "img/laboratorio_3-4_1536.d0b26d43.jpg";